<template>
  <div class="idea">
    <div class="content">
      <div class="tips">{{ t('home.solicitTips1') }}</div>
      <div class="tips">{{ t('home.solicitTips2') }}</div>
    </div>
    <a-button @click.native.stop="submit">{{ t('home.viewMore') }}</a-button>
  </div>
</template>

<script>
import { t } from '@/locales';
export default {
  methods: {
    t,
    submit() {
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ['home_groupStandard_idea'] }).then(res => {
          if (res) {
            this.$router.$push({ path: "/ceppeaSolicit" })
          }
        });
      } else {
        this.$FN.LoginTips();
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
